import { render, staticRenderFns } from "./RedirectedLogs.vue?vue&type=template&id=58c16529&"
import script from "./RedirectedLogs.vue?vue&type=script&lang=js&"
export * from "./RedirectedLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports